module.exports = __webpack_public_path__ + "static/media/radar-selected.f82cfc06.svg";